import React from 'react';

import SelectCountry from '../micro/SelectCountry';
import SelectSegment from '../micro/SelectSegment';

const Segments = ({
  segment
}) => {
  if (segment.length) {
    return (
      <div>
        { segment.split(/\n/).map((item, i) => <div className="target__segment" key={i}>{item}</div>) }
      </div>
    )
  } else {
    return null;
  }
}

const TargetTab = ({
  state,
  handleChange
}) => {
  let audience = 0;
  if (state.country.length) {
    audience = state.country.length * 448325;
  }
  if (state.city) {
    audience -= state.city.length * 250000;
  }
  if (state.segment.length) {
    audience = state.segment.split(/\n/).length * 448325;
  }
  return (
    <div>
      <SelectCountry 
        name="country"
        value={state.country}
        onChange={handleChange} />
      <input type="text" className="input"
        placeholder="Add a State/Province, City or ZIP Code"
        name="city"
        value={state.city} 
        onChange={handleChange} />
      <SelectSegment 
        name="segmentId"
        value={state.segmentId}
        onChange={handleChange} />
      <Segments segment={state.segment} />
      <textarea type="text" className="textarea" rows="4"
        placeholder="Segment the target group"
        name="segment"
        value={state.segment} 
        onChange={handleChange} />
      { !!audience &&
        <div className="checkout__item flex-between">
          <div className="checkout__label">Audience reach</div>
          <div className="checkout__number"><b className="checkout__number--bold">{audience}</b> people</div>
        </div>
      }
    </div>
  )
}

export default TargetTab


// WEBPACK FOOTER //
// ./src/components/campaigns/TargetTab.js